import moment from 'moment';

export const getLabel = label => {
  switch (label) {
    case 'patientName':
      return 'Nimi';
    case 'fromOrganization':
      return 'Lähtöpiste';
    case 'toOrganization':
      return 'Päätepiste';
    case 'fromRoom':
      return 'Lähtöpiste huone';
    case 'toRoom':
      return 'Päätepiste huone';
    case 'accuracy':
      return 'Perilläoloajan tarkkuus';
    case 'equipment':
      return 'Kuljetusväline';
    case 'oxygen':
      return 'Lisähappi';
    case 'remarks':
      return 'Lisätietoja';
    case 'dropletPrecautions':
      return 'Pisaraeristys';
    case 'contactPrecautions':
      return 'Kosketuseristys';
    case 'airbornePrecautions':
      return 'Ilmaeristys';
    case 'NOTHING':
      return 'Ei mitään';
    case 'WHEELCHAIR':
      return 'Pyörätuoli';
    case 'WHEELCHAIR_PORTER':
      return 'Pyörätuoli, kuljettaja tuo';
    case 'BED':
      return 'Sänky';
    case 'SAHKO':
      return 'Sähkötyö';
    case 'RAKENNE':
      return 'Rakenteen korjaus';
    case 'LVI':
      return 'LVI';
    case 'ULKO':
      return 'Ulkoalue';
    case 'JATETURVA':
      return 'Turva';
    case 'KAASUT':
      return 'Kaasut';
    case 'OPASTEET':
      return 'Opasteet';
    case 'TEKNISETPIIRUSTUKSET':
      return 'Tekniset piirustukset';
    case 'TARKKA':
      return 'Tarkka tavoiteaika';
    case 'JOUSTAVA':
      return 'Aika on joustava';
    case 'SOITOSTA':
    case 'pickupOnCall':
      return 'Leikkausjonossa';
    case 'time':
      return 'Perilläoloaika';
    case 'space':
      return 'Tilan tunniste';
    case 'description':
      return 'Tarkennukset, lisähuomiot ym.';
    case 'contactPhone':
      return 'Yhteyshenkilön puhelinnumero.';
    case 'type':
      return 'Korjauksen tyyppi';
    case 'infectionRisk':
      return 'Tartuntavaara';
    case 'isUrgent':
      return 'Kiirellinen';
    case 'collectFeedback':
      return 'Tieto valmistumisesta';
    case 'deliveryAddress':
      return 'Toimitusosoite';
    case 'gasbottles':
      return 'Kaasupullot';
    case 'additionalInfo':
      return 'Lisätietoja';
    case 'identificationNumber':
      return 'Laitteen tunnusnumero';
    case 'deviceUnit':
      return 'Laitteen toimipiste';
    case 'deviceLocation':
      return 'Laitteen tarkempi sijainti';
    case 'maintenanceUnit':
      return 'Huoltoyksikkö';
    case 'accountNumber':
      return 'Liittymän numero';
    case 'accountUnit':
      return 'Liittymän haltijan toimipiste';
    case 'ORDERED':
      return 'Hyväksyttävät tilaukset';
    case 'APPROVED,ACKNOWLEDGED':
      return 'Aktiiviset tilaukset';
    case 'IN_PROGRESS':
      return 'Toimituksessa olevat tilaukset';
    case 'COMPLETED':
      return 'Valmiit tilaukset';
    case 'CANCELED':
      return 'Peruutetut tilaukset';
    case 'APPROVED':
      return 'Tilaus hyväksytty';
    case 'FAILED':
      return 'Epäonnistunut';
    case 'ACKNOWLEDGED':
      return 'Kuitattu';
    case 'ASSIGNED':
      return 'Varattu';
    case 'NORMAALI':
      return 'Normaali';
    case 'PIKA':
      return 'Pika';
    case 'MAARATTY':
      return 'Aikaväli';
    case 'TIETOTURVA':
      return 'Tietoturvapaperi';
    case 'LAAKE':
      return 'Lääkejäte';
    case 'MYRKKY':
      return 'Vaaralliset aineet';
    case 'BIOLOGINEN':
      return 'Eristysjäte';
    case 'KERAYSPAPERI':
      return 'Keräyspaperi';
    case 'ERISTYSPYYKKI':
      return 'Eristyspyykki';
    default:
      return label;
  }
};

export const combineDateAndTime = (date, time) => {
  const validDate = moment(date, 'DD.MM.YYYY').format('YYYY-MM-DD');
  const validTime = moment(time, 'HH:mm').format('HH:mm');
  return moment(`${validDate} ${validTime}`);
};

export const formatSpaces = spaces =>
  spaces &&
  spaces.map(space => {
    const name = space.nickname
      ? `[${space.nickname}] ${space.usage}`
      : space.usage || 'ei tilan nimeä';

    const formatted = `${space.floor}.${space.room}/${space.building} ${name}`;

    return {
      value: formatted,
      label: formatted,
    };
  });

export const getLabelFromFormInfo = (formInfo, fieldName) => {
  if (!formInfo.fields.length) return null;
  const field = formInfo.fields.find(field => field.name === fieldName);
  if (!field || !field.label) {
    console.error(
      `getLabelFromFormInfo: Couldn't find field or field.label for fieldName: ${fieldName}`
    );
    return null; // If needed, place defaults in the forms directly
  }
  return field.label;
};
